import { styled } from "@mui/material";

export const Divider = styled("div")(({ theme }) => ({
  borderBottom: "1px solid rgb(218, 220, 224)",
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2.5),
}));
